// Infraestructura base compartida por todas las capas de API (editor y features).
// Importar este modulo instala el override de window.fetch una sola vez.

import { environment } from './environment';

const originalFetch = window.fetch;
window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (response.status === 503) {
        const cloned = response.clone();
        try {
            const body = await cloned.json();
            if (body?.error?.reason === 'maintenance') {
                // Marca la recarga como provocada por mantenimiento: hay pantallas
                // (checkout) que avisan al salir y deben callarse en este caso.
                window._maintenanceReload = true;
                window.location.reload();
            }
        } catch {
        }
    }
    return response;
};

// Datos de entorno que pide casi toda llamada a la API. Se lee al invocarla, nunca
// en tiempo de modulo: environment se rellena en initEnvironment() y capturarlo al
// importar dejaria el entorno vacio (URLs tipo https://api./...).
export const getRequestData = () => ({
    lang: environment.lang,
    tokenID: environment.tokenID,
    environment: environment.entorno
});

// Base canonica de la API versionada. El parametro cubre a facturacion, que no
// inicializa el singleton environment y resuelve el entorno por su cuenta.
export const getApiBase = (entorno = environment.entorno) => 'https://api.' + entorno + '/v1';

// Solo la cabecera de autenticacion, para los fetch que no pueden usar getHeaders()
// (cuerpos FormData/URLSearchParams donde el navegador fija el Content-Type).
// token: undefined = el de sesion; null = explicitamente sin token; string = override (LTI, facturacion)
export const getAuthHeaders = (token = environment.tokenID) => (
    token ? { 'Authorization': 'Bearer ' + token } : {}
);

export const getHeaders = (lang, contentType = 'none', token = undefined) => {
    let headers = {
        'Accept': 'application/hal+json',
        'Cache-Control': 'no-cache',
        ...getAuthHeaders(token)
    };
    // Sin idioma no se manda la cabecera: incluirla valdria la cadena "undefined".
    if (lang) {
        headers = {
            ...headers,
            'Accept-Language': lang
        }
    }
    switch (contentType) {
        case 'json':
            headers = {
                ...headers,
                'Content-Type': 'application/json'
            }
            break;
        case 'form':
            headers = {
                ...headers,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
            break;
    }
    return headers;
}

// Error de respuesta HTTP con el status accesible, para que las capas superiores
// puedan distinguir un 404 (id inexistente / sin acceso) de un 5xx o caida de red
// y decidir entre redirigir o reintentar.
export const httpError = (label, status) => Object.assign(new Error(label + ' HTTP ' + status), { status });
